import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AutomationEditorDialog } from '@web/modules/automations/editor/automation-editor-page';
import { AUTOMATION_KINDS } from '@web/modules/automations/contract';

const searchSchema = z.object({
  kind: z.enum(AUTOMATION_KINDS).default('rule'),
  folderId: z.string().min(1).optional(),
});

export const Route = createFileRoute('/_app/automations/new')({
  validateSearch: (search) => searchSchema.parse(search),
  component: NewAutomationRoute,
});

function NewAutomationRoute() {
  const { kind, folderId } = Route.useSearch();
  return <AutomationEditorDialog target={{ mode: 'create', kind, folderId: folderId ?? null }} />;
}
